import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=27a47e4b&scoped=true"
import script from "./Reason.vue?vue&type=script&lang=js"
export * from "./Reason.vue?vue&type=script&lang=js"
import style0 from "./Reason.vue?vue&type=style&index=0&id=27a47e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a47e4b",
  null
  
)

export default component.exports